import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { BsLayoutThreeColumns } from "react-icons/bs";

const ColumnSelector = ({ columns, selectedColumns, setSelectedColumns }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleColumnSelect = (column) => {
    if (selectedColumns.includes(column)) {
      setSelectedColumns(selectedColumns.filter((c) => c !== column));
    } else {
      setSelectedColumns([...selectedColumns, column]);
    }
  };

  const handleDropdownToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };

  const handleDropdownHide = () => {
    setShowDropdown(false);
  };

  return (
    <Dropdown
      show={showDropdown}
      onToggle={handleDropdownToggle}
      onHide={handleDropdownHide}
      className="primary-selector"
    >
      <Dropdown.Toggle variant="secondary" id="column-selector">
        <BsLayoutThreeColumns /> Columns
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {columns.map((column) => (
          <Dropdown.Item
            key={column}
            onClick={() => handleColumnSelect(column)}
          >
            <input
              type="checkbox"
              value={column}
              checked={selectedColumns.includes(column)}
              onChange={() => handleColumnSelect(column)}
            />
            &nbsp;{column}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ColumnSelector;
